
import { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { FormValues } from "@/types/loan";
import { Checkbox } from "@/components/ui/checkbox";
import { LegalDialogs } from "./LegalDialogs";

interface SwedishTermsCheckboxProps {
  form: UseFormReturn<FormValues>;
  setTermsOpen: (value: boolean) => void;
  setPrivacyPolicyOpen: (value: boolean) => void;
}

export const SwedishTermsCheckbox = ({
  form,
  setTermsOpen,
  setPrivacyPolicyOpen
}: SwedishTermsCheckboxProps) => {
  const [localTermsOpen, setLocalTermsOpen] = useState(false);
  const [localPrivacyOpen, setLocalPrivacyOpen] = useState(false);

  return (
    <div className="space-y-1 pt-0.5 checkbox-container">
      <FormField
        control={form.control}
        name="termsAccepted"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-2 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600 mt-0.5"
              />
            </FormControl>
            <div className="leading-none">
              <label
                htmlFor="termsAccepted"
                className="text-xs font-medium leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Jag har läst och godkänner{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline font-medium"
                  onClick={() => setLocalTermsOpen(true)}
                >
                  användarvillkoren
                </button>{" "}
                och{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline font-medium"
                  onClick={() => setLocalPrivacyOpen(true)}
                >
                  integritetspolicyn
                </button>
              </label>
              <FormMessage className="text-xs mt-0.5" />
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="marketingConsent"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-2 space-y-0 mt-1">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600 mt-0.5"
              />
            </FormControl>
            <div className="leading-none">
              <label
                htmlFor="marketingConsent"
                className="text-xs font-medium leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Jag samtycker till att ta emot nyhetsbrev och erbjudanden
              </label>
            </div>
          </FormItem>
        )}
      />
      
      <LegalDialogs
        termsOpen={localTermsOpen}
        setTermsOpen={setLocalTermsOpen}
        privacyPolicyOpen={localPrivacyOpen}
        setPrivacyPolicyOpen={setLocalPrivacyOpen}
        language="sv"
        openFullTerms={() => setTermsOpen(true)}
        openFullPrivacy={() => setPrivacyPolicyOpen(true)}
      />
    </div>
  );
};
